import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";

const CustomerConfigUploadForm = () => {
    const [formData, setFormData] = useState({});

    const { id } = useParams();

    const location = useLocation();
    const { data } = location.state || {};
    console.log(location, "LOCATION")

  const [isMainFormSubmitted, setIsMainFormSubmitted] = useState(false);
  const [activeSection, setActiveSection] = useState('Customer');
  const [ fetchOnboardDetails, setfetchOnboardDetails ] = useState([])

  const [onboardId, setOnboardId] = useState(null); // State to store onboardId

  const [ onBoardStatus, setOnBoardStatus ] = useState(null)

  const [ isButtonVisible, setIsButtonVisible ] = useState(true)

  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);

  const [ onBoardType, setOnBoardType ] = useState("Agent")

  const [ menuDropdown, setMenuDropdown ] = useState([])

  const [isFormSubmittedSuccessfully, setIsFormSubmittedSuccessfully] = useState(false);
  const token = localStorage.getItem("authToken");

  console.log(token, "TOKEN")

  const authToken = localStorage.getItem("authToken");
  console.log(authToken, "AUTHTOKEN")

  const [businessPartnertypedd, setBusinessPartnerTypedd] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState({});


  console.log(data, "DAATAONBOARD")

  const navigate = useNavigate();
  // const handleFormSubmit = (data) => {
  //   setIsMainFormSubmitted(true);
  //   console.log("Form Data:", data);
  // };

  // useEffect(() => {
  //   if (data) {
  //       const transformedData = {
  //           bp_type: data.business_partner_type,
  //           bp_name:data.bp_name,
  //           contact_no:data.contact_no,
  //           email_id:data.email_id,
  //           pincode:data.pincode,
  //           city_id:data.city_name,
  //           country_id:data.country_name,
  //           state_id:data.state_name,
  //           bp_address:data.bp_address,
  //           gst_no:data.gst_no,
  //           max_hierarchy_level:data.max_hierarchy_level,
  //           total_user:data.total_user,
  //           user_prefix:data.user_prefix,
  //           adhaarcard:data.adhaarcard,
  //           pan:data.pan,
  //           cancelcheque:data.cancelcheque,
  //           agreementcopy:data.agreementcopy,
  //           businesslicense:data.businesslicense,
  //           environmentalpolicy:data.environmentalpolicy,
  //         status: { label: data.status, value: data.status==="Active"?1:0 },
  //       };
  //       setFormData(transformedData);
  //       console.log(transformedData, "transformedData");
  //     }
  // })

  const handleDocumentFormSubmit = (data) => {
    console.log("Document Form Data:", data);

    navigate(ROUTES_NAVIGATION.CUSTOMERDETAILS);
  };

  const handleNavigate = () => {
    navigate('/admin/manage-onboard/onboard/create-customer');
  };

  useEffect(() => {
    fetchMenuDropdown();
  },[])

  const fetchMenuDropdown = async () => {
    try {
      const response = await axiosInstance.get('/bp-onboard/menu',{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const formattedData = response.data.data.data
      const menuOptions = formattedData.map(item => ({
        value: item.menu_id,
        label: item.menu_name,
      }));
      setMenuDropdown(menuOptions);
      console.log(formattedData, "MENU DROPDOWN DATA")

    } catch (error) {
      console.error('Error fetching campaign list:', error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log("formDataHandleSubmit",formData);
// Check if any document is uploaded
const documents = [
  formData.adhaarcard,
  formData.pan,
  formData.cancelcheque,
  formData.agreementcopy,
  formData.businesslicense,
  formData.environmentalpolicy,
];

const hasDocuments = documents.some((doc) => doc);

if (!hasDocuments) {
  showCustomAlert({
    title: "No Documents Uploaded",
    text: "Please upload at least one document before proceeding.",
    icon: "warning",
    confirmButtonText: "OK",
  });
  return;
}

    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    setIsLoading(true);

    console.log("clicked")
    showCustomAlert({
      title: "Confirmation",
      text: "Are you sure you want to create this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      callback: async () => {
    try {
      const response = await axiosInstance.patch(`/bp-onboard/updatebpoffline/${id}`, {
       // onboard_process_type: formData.onboard_process_type,
        onboard_status: 2,
        //bp_type: formData.business_partner_type,
        bp_name: formData.bp_name,
        contact_no: formData.contact_no,
        email_id: formData.email_id,
        pincode: formData.pincode,
        city_id: formData.city_id,
        country_id: formData.country_id,
        state_id: formData.state_id,
        bp_address: formData.bp_address,
        gst_no: formData.gst_no,
        //status: formData.status.value === "Active" ? 1 : 0,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      console.log("APIResponse", response.data?.data);
      const onboardid=response?.data?.data?.onboard_id
      const onBoardStatus = response?.data?.data?.onboard_status
      setOnBoardStatus(onBoardStatus)
      console.log(onBoardStatus, "onBoardSttaus")
      setOnboardId(onboardid);
      console.log("onboardid>>>",onboardid);
      //setcreateOnBoardStatus(resposne.data)
      // toastSuccess("Data added successfully!");
      setIsFormSubmittedSuccessfully(true)
      setIsButtonVisible(false)
      showCustomAlert({
        title: "Success",
        text: "Data Updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
        
      });
      if(response.status===200){
        await uploadDocumentForm(formData);
      }

    } catch (error) {
      console.log(error, "error")
      const errorMessage = error.response?.data?.message;
      showAlert({
        title: "Something went wrong",
        icon:"error",
        text:
          errorMessage ||
          "An error occurred while processing your request.",
       
      });
      // toastError("Failed to add data. Please try again.");
    } finally {
      setIsLoading(false)
    }
  }
});}
const uploadDocumentForm = async (formData) => {
  const uploadData = new FormData();
  uploadData.append("document_type", "1,2,3,4,5,6");
  uploadData.append("onboard_bp_id", id);

  
  // Append the files to the FormData if present
  if (formData.adhaarcard) {
    uploadData.append("uploadFile", formData.adhaarcard);
  }
  if (formData.pan) {
    uploadData.append("uploadFile", formData.pan);
  }
  if (formData.cancelcheque) {
    uploadData.append("uploadFile", formData.cancelcheque);
  }
  if (formData.agreementcopy) {
    uploadData.append("uploadFile", formData.agreementcopy);
  }
  if (formData.businesslicense) {
    uploadData.append("uploadFile", formData.businesslicense);
  }
  if (formData.environmentalpolicy) {
    uploadData.append("uploadFile", formData.environmentalpolicy);
  }

  try {
    const response = await axiosInstance.post(
      "/bp-onboard/uploadDocumentCus",
      uploadData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      }
    );

    console.log("added successfully:", response.data);
    window.close();
    navigate(""); 
  } catch (error) {
    console.error("Error adding unit:", error);
  }
};


// const uploadDocumentForm =  async() => {
//   const uploadData = new FormData();

//   // uploadData.append('document_type', "1","2","3","4");
//   // uploadData.append("document_type", "'1','2','3','4'")
//   uploadData.append("document_type","1,2,3,4,5,6")
//   uploadData.append('onboard_bp_id', id);

//   if (formData.adhaarcard) {
//     uploadData.append('uploadFile', formData.adhaarcard);
//   }
//   if (formData.pan) {
//     uploadData.append('uploadFile', formData.pan);
//   }
//   if (formData.cancelcheque) {
//     uploadData.append('uploadFile', formData.cancelcheque);
//   }
//   if (formData.agreementcopy) {
//     uploadData.append('uploadFile', formData.agreementcopy);
//   }
//   if (formData.businesslicense) {
//     uploadData.append('uploadFile', formData.businesslicense);
//   }
//   if (formData.environmentalpolicy) {
//     uploadData.append('uploadFile', formData.environmentalpolicy);
//   }

//     try {
//       const response = await axiosInstance.post('/bp-onboard/uploadDocumentCus',uploadData, 
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${authToken}`,
//         }
//       }
//     );
  
//       console.log("added successfully:", response.data);
//       //toastSuccess("Product Data fetched successfully!"); 

//       // if (response.status === 200) {
//       //   // Call uploadDocumentForm after successful configForm submission
//       //   await createUpdateAcess(formData);
//       //   toastSuccess("Data added successfully!");
//       // }
//       navigate("") 
//     } catch (error) {
//       console.error('Error adding unit:', error);
//       // toastError("Failed to add data. Please try again.");
//       console.error("Error submitting form:", error);
//     }
//     // const response = await axiosInstance.post("")

//   }


//   const handleConfig = async (formData) => {
//     console.log("handleconfigFormData",formData);
//     const errors = {};
//     let isValid = true;

//     ConfigInputs.forEach((field) => {
//       if (field.validation && field.validation.required) {
//         if (!formData[field.name]) {
//           errors[field.name] = "This field is required";
//           isValid = false;
//         }
//       }
//     });

//     CustomerInputsAfterSuccess.forEach((field) => {
//       if (field.validation && field.validation.required) {
//         if (!formData[field.name]) {
//           errors[field.name] = "This field is required";
//           isValid = false;
//         }
//       }
//     });

//     if (!isValid) {
//       setValidationErrors(errors);
//       return;
//     }

//     setIsLoading(true);

//     // console.log("clicked", formData)
//     showCustomAlert({
//       title: "Success",
//       text: "Are you sure you want to create this record?",
//       icon: "success",
//       confirmButtonText: "Yes",
//       cancelButtonText: "No",
//       callback: async () => {

//     try {

//     //   // Log the payload to be sent
//     // const payload = {
//     //   max_hierarchy_level: 0,
//     //   total_user: 0,
//     //   user_prefix: 0,
//     //   onboard_status: 2,
//     // };
//     // console.log("Payload to be sent:", payload);

//     //   const response = await axiosInstance.patch(`/bp-onboard/updateConfigCus/${id}`, payload, {
//     //     headers: {
//     //       "Content-Type": "application/json",
//     //       Authorization: `Bearer ${authToken}`,
//     //     }
//     //   });

//     //   console.log("API Response:", response.data);
//     //   if (response.status === 200) {
//         // Call uploadDocumentForm after successful configForm submission
        
//        await uploadDocumentForm(formData);

//        // await createUpdateAcess(formData);
//         // toastSuccess("Data added successfully!");
//       //}
//       // toastSuccess("Data added successfully!");
//     } catch (error) {
//       console.log(error, "error")
//       // toastError("Failed to add data. Please try again.");
//     } finally {
//       setIsLoading(false)
//       window.close();  // Close the tab
//     }
//   },
// });
//     // navigate("/admin/manage-onboard/onboard")
//   }

  const createUpdateAcess = async (formData) => {

    console.log(formData, "FORMDATAA")
    const menuAccessIds = formData.accessModule.join(",");

    const payload = {
      menu_access: menuAccessIds,
      onboard_status: 2,
      remark:formData.remarks,

    }
    console.log(payload, "UpdateAccess Payload")
    try {
      const resposne = await axiosInstance.patch(`/bp-onboard/updateAccess/${onboardId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      })

      console.log(resposne.data, "Api Resposne:")
    }catch (error) {
      console.log("ERROR", error)
      // toastError("Failed to add data. Please try again.");
    } finally {
      setIsLoading(false)
    }
  }




  const fetchBusinessPartnerType = async () => {
    try {
      const resposne = await axiosInstance.post("/businesspartnertype/ddlbusinesspartnertype", {}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      })
      const options = resposne.data.data.data.map(data => ({
        label: data.NAME,
        value: data.ID,
      }));

      setBusinessPartnerTypedd(options)

    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    fetchBusinessPartnerType();
  }, [])

  

  const ConfigInputs = [
    {
      name: "max_hierarchy_level",
      label: "Max Hierarchy Level",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
   // validation: { required: true,maxLength:2 },
    },
    {
      name: "total_user",
      label: "Total Users",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true ,maxLength:2},
    },
    {
      name: "user_prefix",
      label: "User Prefix",
      type: "text",
     // required: true,
      gridClass: "col-lg-4",
      //validation: { required: true },
    },
  ]

  

  const CustomerInputsAfterSuccess = [
    {
      name: "adhaarcard",
      label: "Adhaar Card",
      type: "file",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "pan",
      label: "Pan Card",
      type: "file",
      required: false,
      gridClass: "col-lg-4",
      validation: { required: false },
    },
    {
      name: "cancelcheque",
      label: "Cancel Cheque",
      type: "file",
      required: false,
      gridClass: "col-lg-4",
      validation: { required: false },
    },
    {
      name: "agreementcopy",
      label: "Agreement Copy",
      type: "file",
      required: false,
      gridClass: "col-lg-4",
      validation: { required: false },
    },
    {
      name: "businesslicense",
      label: "Business Licence & Permits",
      type: "file",
      required: false,
      gridClass: "col-lg-4",
      validation: { required: false },
    },
    {
      name: "environmentalpolicy",
      label: "Environment Policy",
      type: "file",
      required: false,
      gridClass: "col-lg-4",
      validation: { required: false },
    },
    // {
    //   name: "action",
    //   label: "Action",
    //   required: true,
    //   type: "dropdown",
    //   options: [
    //     // { label: "New", value: "New" },
    //     { label: "Update", value: "Update" },
    //     { label: "Approve", value: "Approve" },
    //   ],
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
  ];

  const CustomerInputs = [
    // {
    //   name: "onboard_process_type",
    //   label: "On Board Business Type",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
      
    // },
    // {
    //   name: "bp_type",
    //   label: "Business Partner Type",
    //   type: "dropdown",
    //   required: true,
    //   options: businessPartnertypedd,
    //   // options: [
    //   //   { label: "OEM", value: "OEM" },
    //   //   { label: "OEM2", value: "OEM2" },
    //   // ],
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
      
    // },
    {
      name: "bp_name",
      label: "Business Partner Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, maxLength:50 },
      
    },
    {
      name: "contact_no",
      label: "Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      },
      
    },
    {
      name: "email_id",
      label: "Email Address",
      type: "email",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      
    },
    {
      name: "bp_address",
      label: "Business Partner Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,maxLength:50 },
      
    },
    {
      name: "pincode",
      label: "PinCode",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      
    },
    {
      name: "city",
      label: "City",
      type: "text",
      gridClass: "col-lg-4",
      validation: { required: true },
      
    },
    {
      name: "state",
      label: "State",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      
    },
    {
      name: "gst_no",
      label: "GST No.",
      type: "text",
      required: false,
      gridClass: "col-lg-4",
      // validation: { required: true },
      
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "dropdown",
    //   required: true,
    //   options: [
    //     { label: "Active", value: 1 },
    //     { label: "Inactive", value: 0 },
    //   ],
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
      
    // },
    // {
    //   name: "action",
    //   label: "Action",
    //   required: true,
    //   type: "dropdown",
    //   options: [
    //     { label: "New", value: "New" },
    //     // { label: "Update", value: "Update" },
    //     // { label: "Approve", value: "Approve" },
    //   ],
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
  ];


  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      onboard_process_type: "Agent"
    }));
  }, []);


  const backNavigate = () => {
    navigate("/admin/manage-onboard/onboard")
  }

  // useEffect(() => {
  //   fetchOnBoardDetails()
  // },[])

  useEffect(() => {
    fetchOnBoardDetails(id);
  }, [id]);


  const fetchOnBoardDetails = async (id) => {
    try{
      const response = await axiosInstance.get(`/bp-onboard/getcustomerDetails/${id}`,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      })

      const fetchedData = response.data.data
      const transformedData = {
        onboard_process_type: fetchedData.onboard_process_type,
        bp_name:fetchedData.bp_name,
        bp_type:fetchedData.bp_type,
        contact_no:fetchedData.contact_no,
        email_id:fetchedData.email_id,
        pincode:fetchedData.pincode,
        city_id:fetchedData.city_id,
        country_id:fetchedData.country_id,
        state_id:fetchedData.state_id,
        bp_address:fetchedData.bp_address,
        gst_no:fetchedData.gst_no,
        remark:fetchedData.remark,
        status: fetchedData.status,
      }
      setFormData(transformedData)
      console.log(fetchedData, "fetchConfigData")
      setfetchOnboardDetails(fetchedData)
    }catch(error){
      console.log(error, "error")
    }
  }

  return (
    <>
      <div className="backbutton mt-2 mb-2">
        {/* <img onClick={backNavigate} src={backicon} alt="back" /> */}
        <span className="backbtntitle">Customer Form</span>
      </div>
      <div className="form-container">
        <div style={{display:"flex", gap:"10px"}}>
        </div>
        <div className="cust-det-title mt-2 mb-2">
          Please Enter the Details
        </div>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      {/* <div className="btncontainer mt-3">
      {isButtonVisible && (
          <button
            onClick={() => handleFormSubmit(formData)}
            className="submit-btn"
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        )}
      </div> */}

      {/* {isFormSubmittedSuccessfully && ( */}
        <>
          <div className="invisible">
            <span className="backbtntitle invisible">Configuration</span>
            <DynamicForm
              formConfig={ConfigInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
            {/* < button onClick={() =>handleConfig(formData)} >submit</button> */}
          </div>
          <div className="pt-4">
            <span className="backbtntitle">Upload Documents and Details</span>
            <DynamicForm
        formConfig={[
          ...CustomerInputsAfterSuccess,
          ...(showAdditionalInputs
            ? [
                {
                  name: "accessModule",
                  label: "Access Module",
                  type: "multiselectdropdown",
                  options: menuDropdown,
                  required: true,
                  gridClass: "col-lg-4",
                },
                {
                  name: "remarks",
                  label: "Remarks",
                  type: "text",
                  required: true,
                  gridClass: "col-lg-4",
                },
              ]
            : []),
        ]}
        formData={formData}
        setFormData={setFormData}
        onSubmit={uploadDocumentForm}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
      />
          </div>

          <div  onClick={()=> handleFormSubmit(formData)} style={{cursor:"pointer"}}  className="agentSubmit-btn">
            Submit
          </div>
        </>
    {/* //   )} */}
      </div>

    </>
  );
};

export default CustomerConfigUploadForm;
